import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  html, body  {
    margin:0;
    padding: 0;
  }
  html{
    height: 100%;
    width: 100%;
    font-family: 'Montserrat', sans-serif;
  }
  * {
    box-sizing: border-box;
  }
  body {
    /* font-family: "Work Sans", sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
